module.exports = __webpack_public_path__ + "static/media/node.e8991489.png";